import * as Effects from "redux-saga/effects";
import { fork, put, takeLatest } from "redux-saga/effects";

import config from "../../config";
import { locales } from "../../locales/locales.enum";
import translationAU from "../../locales/OrderManagement/au.json";
import translationUS from "../../locales/OrderManagement/us.json";
import { authActions } from "../auth/auth.slice";
import { GrantType } from "../auth/models";
import { errorActions, ErrorActionType } from "./error.slice";
import { HTTPStatusCode } from "./models";

export const defaultErrorHandling = {
  heading:
    config.version === locales.AU
      ? translationAU.defaultErrorHeading
      : translationUS.defaultErrorHeading,
  statusCode: HTTPStatusCode.UNEXPECTEDERROR,
  message: "",
  title: "",
};

export function* handleErrorResponse(
  action: ErrorActionType
): Generator<unknown, void> {
  if (action.payload?.statusCode === HTTPStatusCode.UNAUTHORISED) {
    const payload = {
      refreshToken: config.refreshToken,
      grantType: GrantType.REFRESH,
    };
    try {
      yield put(authActions.refreshToken(payload));
    } catch (error) {
      console.error(error);
    }
  }
}

export function* watchErrorResponse(): Generator<
  Effects.ForkEffect<never>,
  void
> {
  yield takeLatest(errorActions.setErrorAPIResponse.type, handleErrorResponse);
}

const saga = [fork(watchErrorResponse)];

export default saga;
